import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import Loader from "../../../../components/loader/Loader";
import SendNotification from "../../../../components/sendNotification/SendNotification";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchPaginatedUsers } from "../../../../features/users/usersSlice";
import styles from "./allUsers.module.css";
import OneUser from "./oneUser/OneUser";

const AllUsers = () => {
  const dispatch = useDispatch();
  const {
    list: users,
    fetchStatus,
    currentPage,
    totalPages,
  } = useSelector((state) => state.users);

  const { rolePermissions } = useSelector((state) => state.user);

  const userListRef = useRef();

  const handleScroll = useCallback(() => {
    const container = userListRef.current;
    if (!container || fetchStatus === "loading") return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      currentPage < totalPages
    ) {
      dispatch(fetchPaginatedUsers({ page: currentPage + 1 }));
    }
  }, [dispatch, fetchStatus, currentPage, totalPages]);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchPaginatedUsers({ page: 1 }));
    }
  }, [dispatch, fetchStatus]);

  useEffect(() => {
    const container = userListRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch, currentPage, totalPages, handleScroll]);

  const displayUsers = users.map((item) => (
    <OneUser
      name={item.name}
      email={item.email}
      region={item.region}
      userImage={item.userImage}
      addedTime={item.createdAt}
      modifiedTime={item.updatedAt}
      key={item._id}
      userId={item._id}
      banned={item.banned}
      gameIds={item.gameIds}
    />
  ));

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <TextWrapper textStyle="textTitle">جميع اللاعبين</TextWrapper>
        {rolePermissions.includes("send-all-notification") && (
          <div className={styles.headerAction}>
            <SendNotification targetType={"all"} type={"general"} />
          </div>
        )}
      </div>
      <div className={styles.allUsersWrapper}>
        <DisplayContainer ref={userListRef} className={styles.usersDisplay}>
          {displayUsers}
          {fetchStatus === "loading" && (
            <div className={styles.loaderContainer}>
              <Loader />
            </div>
          )}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default AllUsers;
